module.exports = __webpack_public_path__ + "static/media/daycareBanner3.8abf785d.png";